export default "__VITE_ASSET__b2f155ab__"